import { useCallback, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider.js';
import { listGps, validateGps } from '../api/quality.js';
import { ApiError } from '../api/client.js';

export function GpsValidationPage(): ReactNode {
  const { id = '' } = useParams<{ id: string }>();
  const { token } = useAuth();
  const [rows, setRows] = useState<readonly unknown[]>([]);
  const [form, setForm] = useState({ gpsId: '', siteLat: '', siteLng: '', execLat: '', execLng: '', accuracy: '' });
  const [error, setError] = useState<string | null>(null);
  const [msg, setMsg] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setRows(await listGps(id, token)); } catch (err) { setError(err instanceof ApiError ? err.message : 'Load failed'); }
  }, [id, token]);
  useEffect(() => { void load(); }, [load]);

  async function submit(): Promise<void> {
    setError(null); setMsg(null); setBusy(true);
    try {
      await validateGps(id, {
        gpsId: form.gpsId,
        siteLatitude: Number(form.siteLat),
        siteLongitude: Number(form.siteLng),
        execLatitude: Number(form.execLat),
        execLongitude: Number(form.execLng),
        accuracyM: Number(form.accuracy),
      }, token);
      setMsg('Saved');
      await load();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Save failed');
    } finally { setBusy(false); }
  }

  return (
    <main aria-label="gps-validation">
      <h1>GPS validation — {id}</h1>
      {error ? <div role="alert">{error}</div> : null}
      {msg ? <div role="status">{msg}</div> : null}
      <div aria-label="gps-count">{rows.length} record(s)</div>
      <form aria-label="gps-form" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <label>GPS ID<input aria-label="gpsId" value={form.gpsId} onChange={(e) => setForm({ ...form, gpsId: e.target.value })} required /></label>
        <label>Site Lat<input aria-label="siteLat" value={form.siteLat} onChange={(e) => setForm({ ...form, siteLat: e.target.value })} required /></label>
        <label>Site Lng<input aria-label="siteLng" value={form.siteLng} onChange={(e) => setForm({ ...form, siteLng: e.target.value })} required /></label>
        <label>Exec Lat<input aria-label="execLat" value={form.execLat} onChange={(e) => setForm({ ...form, execLat: e.target.value })} required /></label>
        <label>Exec Lng<input aria-label="execLng" value={form.execLng} onChange={(e) => setForm({ ...form, execLng: e.target.value })} required /></label>
        <label>Accuracy (m)<input aria-label="accuracy" value={form.accuracy} onChange={(e) => setForm({ ...form, accuracy: e.target.value })} required /></label>
        <button type="submit" disabled={busy}>Validate</button>
      </form>
    </main>
  );
}
